import React from 'react';
import { MapPinIcon, TargetIcon, EyeIcon } from 'lucide-react';
export function About() {
  return <section id="about" className="py-32 lg:py-40 bg-cream-dark relative overflow-hidden" data-id="element-1">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-cream transform -skew-x-12 translate-x-20 opacity-50 pointer-events-none" data-id="element-2" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-20 items-start" data-id="element-4">
          {/* Left Column: Overview & Location */}
          <div className="lg:col-span-7 space-y-16" data-id="element-5">
            <div data-id="element-6">
              <div className="flex items-center space-x-4 mb-6" data-id="element-7">
                <div className="h-px w-8 bg-[#D4AF37]" data-id="element-8"></div>
                <h2 className="text-xs font-cormorant font-bold tracking-[0.3em] text-[#D4AF37] uppercase" data-id="element-9">
                  Firm Overview
                </h2>
              </div>

              <h3 className="font-playfair text-4xl md:text-6xl font-bold text-navy tracking-tight mb-10 leading-tight" data-id="element-10">
                Innovative, practical, and{' '}
                <span className="italic font-light text-[#2567A4]" data-id="element-11">
                  client-focused
                </span>{' '}
                legal solutions.
              </h3>

              <div className="prose prose-lg text-gray-600 font-light leading-relaxed" data-id="element-12">
                <p className="mb-8 text-xl font-cormorant text-gray-800 leading-relaxed" data-id="element-13">
                  Wanja Konji & Company Advocates is a full-service law firm
                  established in March 2025. Duly registered under the Laws of
                  Kenya, we are committed to delivering innovative, practical,
                  and client-focused legal solutions.
                </p>
                <p className="mb-8" data-id="element-14">
                  Founded on the principles of integrity, excellence, and
                  efficiency, the firm serves both individuals and corporates,
                  providing trusted counsel in an increasingly dynamic legal and
                  regulatory environment. Under the leadership of its two
                  principal Advocates, Sheila Wanja Konji and Mellody Mwende
                  Mwavichi, the firm integrates legal, compliance, and
                  governance expertise to deliver holistic solutions.
                </p>
                <p data-id="element-15">
                  Unlike traditional legal service providers, we partner with
                  clients to sustainably grow and strengthen their businesses,
                  ensuring that legal solutions are aligned with long-term
                  strategic goals.
                </p>
              </div>
            </div>

            {/* Professional Office Image */}
            <div className="relative h-[400px] overflow-hidden border border-[#D4AF37]/20 shadow-[0_20px_50px_rgba(0,0,0,0.08)] group" data-id="element-16">
              <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=2069" alt="Professional law office environment" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 transform group-hover:scale-105" data-id="element-17" />
              <div className="absolute inset-0 bg-navy/20 mix-blend-multiply" data-id="element-18" />
              <div className="absolute inset-0 border-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all duration-700 m-4" data-id="element-19" />
            </div>

            <div className="flex items-start space-x-6 p-8 bg-cream border border-[#D4AF37]/20 shadow-[0_8px_30px_rgb(0,0,0,0.04)] relative group" data-id="element-20">
              <div className="absolute top-0 left-0 w-1 h-full gold-gradient-bg" data-id="element-21" />
              <div className="w-12 h-12 rounded-full bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0 mt-1 group-hover:bg-[#D4AF37] transition-colors duration-500" data-id="element-22">
                <MapPinIcon className="h-5 w-5 text-[#D4AF37] group-hover:text-white transition-colors duration-500" strokeWidth={1.5} data-id="element-23" />
              </div>
              <div data-id="element-24">
                <h4 className="text-xs font-bold tracking-[0.2em] text-navy uppercase mb-2" data-id="element-25">
                  Headquarters
                </h4>
                <p className="font-cormorant text-xl text-gray-700 italic" data-id="element-26">
                  Applewood Adams, 4th Floor, Suite 403
                  <br data-id="element-27" />
                  Ngong Road, Nairobi
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Vision & Mission */}
          <div className="lg:col-span-5 space-y-10 mt-10 lg:mt-0" data-id="element-28">
            {/* Vision Card */}
            <div className="bg-cream p-12 shadow-[0_20px_50px_rgba(0,0,0,0.05)] relative overflow-hidden group border border-gray-100 hover:border-[#D4AF37]/30 transition-colors duration-500" data-id="element-29">
              {/* Decorative corners */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-30" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-31" />

              <div className="absolute -top-10 -right-10 p-8 opacity-5 group-hover:opacity-10 transition-opacity duration-700 transform group-hover:scale-110" data-id="element-32">
                <EyeIcon className="w-48 h-48 text-[#D4AF37]" strokeWidth={1} data-id="element-33" />
              </div>

              <div className="relative z-10" data-id="element-34">
                <div className="mb-8" data-id="element-35">
                  <EyeIcon className="h-8 w-8 text-[#D4AF37]" strokeWidth={1.5} data-id="element-36" />
                </div>
                <h3 className="font-playfair text-3xl font-bold text-navy mb-6 tracking-tight" data-id="element-37">
                  Our Vision
                </h3>
                <p className="font-cormorant text-xl text-gray-600 leading-relaxed italic" data-id="element-38">
                  To be a trusted, legal partner delivering cutting-edge
                  solutions and advancing justice in Kenya and beyond.
                </p>
              </div>
            </div>

            {/* Mission Card */}
            <div className="bg-navy p-12 shadow-[0_20px_50px_rgba(10,22,40,0.2)] relative overflow-hidden group border border-[#2567A4]/30" data-id="element-39">
              {/* Decorative corners */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-[#D4AF37] opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-40" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-[#D4AF37] opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-41" />

              <div className="absolute -top-10 -right-10 p-8 opacity-10 group-hover:opacity-20 transition-opacity duration-700 transform group-hover:scale-110" data-id="element-42">
                <TargetIcon className="w-48 h-48 text-[#D4AF37]" strokeWidth={1} data-id="element-43" />
              </div>

              <div className="relative z-10" data-id="element-44">
                <div className="mb-8" data-id="element-45">
                  <TargetIcon className="h-8 w-8 text-[#D4AF37]" strokeWidth={1.5} data-id="element-46" />
                </div>
                <h3 className="font-playfair text-3xl font-bold text-white mb-6 tracking-tight" data-id="element-47">
                  Our Mission
                </h3>
                <p className="font-cormorant text-xl text-blue-100 leading-relaxed italic" data-id="element-48">
                  To provide accessible, efficient, and tailored legal services
                  that meet the diverse needs of our clients while upholding the
                  highest ethical and professional standards.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}